import React from 'react';
import usePreselectedLabels from '@/lib/hooks/swr/usePreselectedLabels';
import type Label from '@/types/Label';

function LabelValue({ value = [] }: { value: string[] }) {
  const { data }: { data?: Label[] } = usePreselectedLabels(value);

  return data ? (
    <span>{data.map(({ labelName }) => labelName).join(', ')}</span>
  ) : null;
}

export default LabelValue;
